<template>
   <b-icon :icon="icon" aria-hidden="true"></b-icon>
</template>

<script>
export default {
  name: "Ic1",
  props: ["icon"],
};
</script>

<style scoped>
</style>